import Vue from 'vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../../assets/shmu.scss'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import SHMUconf from '../../shmu_conf'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import i18n from './i18n'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)
Vue.use(VueMoment)

import VueLocalStorage from 'vue-ls';
let options = {
  namespace: 'shmu__'
};
Vue.use(VueLocalStorage, options);

Vue.config.productionTip = false

let language = 'sk';
if (window.wn_lang) {
  language = window.wn_lang;
}

i18n.locale = language;


new Vue({
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
